import { render, staticRenderFns } from "./ViewFullscreen.vue?vue&type=template&id=178562c0&"
import script from "./ViewFullscreen.vue?vue&type=script&lang=js&"
export * from "./ViewFullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports